import gql from 'graphql-tag';

import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { getConfluenceContentAri } from '@confluence/content-types-utils/entry-points/getConfluenceContentAri.ts';

type PreloadAutohighlightsArgs = {
	contentId: string;
	cloudId: string;
	activationId: string;
	contentType: string;
};

// This function is only used for SSR and is being called in the preloadViewPageRoute.ts file. This preloads data that is then fetched from the cache during SSR in the contextual reading aids package -> PageContentRendererFabric component.
export const preloadAutohighlights = ({
	contentId,
	cloudId,
	activationId,
	contentType,
}: PreloadAutohighlightsArgs) => {
	const entityAri = getConfluenceContentAri({
		siteId: cloudId,
		resourceType: contentType,
		resourceId: contentId,
		activationId: '',
	});
	const workspaceId = getConfluenceContentAri({
		siteId: cloudId,
		resourceType: 'workspace',
		resourceId: activationId,
		activationId: '',
	});
	return queryAgg({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: PlatformHighlightKeywordsQuery,
		variables: {
			workspaceId,
			entityAri,
		},
	});
};

// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Preloaded GraphQL Operation
export const PlatformHighlightKeywordsQuery = gql`
	query PlatformHighlightKeywordsQuery(
		$entityAri: String!
		$workspaceId: String!
		$jiraReporterAccountId: String
		$jiraAssigneeAccountId: String
		$inputText: KnowledgeDiscoveryKeyPhraseInputText
	) {
		knowledgeDiscovery {
			keyPhrases(
				entityAri: $entityAri
				workspaceId: $workspaceId
				jiraReporterAccountId: $jiraReporterAccountId
				jiraAssigneeAccountId: $jiraAssigneeAccountId
				inputText: $inputText
			) @optIn(to: "KnowledgeDiscovery Get Key Phrases") {
				__typename
				... on KnowledgeDiscoveryKeyPhraseConnection {
					nodes {
						... on KnowledgeDiscoveryKeyPhrase {
							keyPhrase
							category
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
